import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  border-radius: 0 0 10px 10px;
  display: flex;
  font-family: 'Avenir Next', sans-serif;
  height: 60px;
  margin-bottom: 20px;
  max-width: 90%;
  width: 100%;

  div {
    padding-bottom: 5px;
  }
`;

export const UserInfo = styled.div`
  align-items: center;
  border-left: 1px solid #e0e0e0;
  color: #01509c;
  display: flex;
  font-size: 13px;
  font-weight: bold;
  height: 100%;

  svg {
    display: initial;
    font-size: 20px;
    margin: 0px 5px 0 25px;
  }
`;

export const Buttons = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  margin-right: 1rem;
  padding-bottom: 0 !important;

  & > a {
    margin-right: 0.5rem;
  }
`;

export const Logout = styled.div`
  align-items: center;
  color: #707070;
  display: flex;

  a {
    margin: 0 25px;
  }
`;
